import AlarmList from './AlarmList';
import AlarmShow from './AlarmShow';

export const alarmViews = {
    list: AlarmList,
    show: AlarmShow,
};